import { render, staticRenderFns } from "./ExaminationRegister.vue?vue&type=template&id=3fdde5f7&scoped=true"
import script from "./ExaminationRegister.vue?vue&type=script&lang=js"
export * from "./ExaminationRegister.vue?vue&type=script&lang=js"
import style0 from "./ExaminationRegister.vue?vue&type=style&index=0&id=3fdde5f7&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fdde5f7",
  null
  
)

export default component.exports